<template>
  <div
    class="success"
    :style="'min-height:' + (fullHeight - 50) + 'px;'"
    style="background-color: #fff"
  >
    <!-- 头图 -->
    <div class="headImgs">
      <img src="../../assets/imgs/apply/bg.png" />
    </div>
    <div class="messageBox">
      <div class="top">
        <div class="name">
          <div class="hander">
            <img :src="baseUrl + dataList.proIcon" />
            <span>{{ dataList.name }}</span>
          </div>
          <div class="bankName">{{ dataList.bankName }}</div>
        </div>
        <div class="details">
          <div class="top">基本信息</div>
          <div class="btn">
            <div>
              授信额度
              <span style="color: #b90c1c"
                >{{ dataList.loanLimitFloor }} - {{ dataList.loanLimitCap
                }}<span>万元</span></span
              >
            </div>
            <div>
              利率范围
              <span
                >{{ dataList.interestRateFloor }}-{{
                  dataList.interestRateCap
                }}
                %</span
              >
            </div>
            <div>
              贷款期限
              <span
                >{{ dataList.minLoanTime }}-{{ dataList.maxLoanTime }} 月</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="title">产品信息</div>
        <div class="list">
          <div>
            产品介绍：<span>{{ dataList.proIntroduction }}</span>
          </div>
          <div>
            贷款类型： <span>{{ dataList.typeName || "信用" }}</span>
          </div>
          <div>
            申请条件：<span>{{ dataList.conditions }}</span>
          </div>
          <div>
            所需材料：<span>{{ dataList.materials }}</span>
          </div>
        </div>
      </div>

      <div class="button">
        <el-button
          type="primary"
          style="
            width: 210px;
            height: 56px;
            box-shadow: 0px 8px 4px 0px rgba(0, 0, 0, 0.12);
            border-radius: 11px;
            font-size: 22px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
          "
          @click="SourceType == null ? noShow() : show()"
          >立即申请</el-button
        >
      </div>
      <el-dialog
        title="申请金额"
        top="35vh"
        :visible.sync="dialogVisible"
        width="20%"
        :show-close="false"
        :modal-append-to-body="false"
        :lock-scroll="false"
        :close-on-click-modal="false"
      >
        <span>申请金额：</span>
        <div class="ipt">
          <el-input-number
            label="万"
            style="width: 80%"
            v-model="input"
            :min="dataList.loanLimitFloor"
            :max="dataList.loanLimitCap"
            placeholder="0.0"
            :controls="false"
            @input="Change"
          ></el-input-number>
          万
        </div>
        <div style="text-align: right">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="enter">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="success"
        :width="dialogWidth"
        :modal-append-to-body="false"
        :lock-scroll="false"
      >
        <div style="display: flex; align-items: center; flex-direction: column">
          <img
            src="../../assets/imgs/apply/release.png"
            style="height: 84px; width: 84px"
          />
          <p style="font-size: 18px; font-weight: 800">您的需求已发布成功</p>
          <div
            style="
              display: flex;
              align-items: flex-start;
              flex-direction: column;
            "
          >
            <div style="display: flex; align-items: center">
              <img
                style="width: 48px; height: 40px"
                src="../../assets/imgs/apply/service.png"
                alt=""
              />
              <div
                style="display: flex; flex-direction: column; margin-left: 10px"
              >
                <span
                  style="font-size: 16px; color: #2a2a2a; white-space: nowrap"
                  >客户经理将与您联系，也可自行联系：
                </span>
                <span
                  style="margin-top: 8px"
                  v-if="phone != null && phone != ''"
                  >产品专员:{{ this.Name }} 联系电话: {{ phone }}</span
                >
              </div>
            </div>
            <div
              style="display: flex; align-items: flex-start; margin-top: 20px"
            >
              <img
                style="width: 48px; height: 40px"
                src="../../assets/imgs/apply/place.png"
                alt=""
              />
              <div
                style="display: flex; flex-direction: column; margin-left: 10px"
              >
                <span
                  style="font-size: 16px; color: #2a2a2a; white-space: nowrap"
                  >线下办理产品地点：
                </span>

                <div
                  style="height: 200px; overflow: auto"
                  v-if="adressList.length != 0"
                >
                  <div
                    v-for="(item, index) in adressList"
                    :key="index"
                    style="
                      display: flex;
                      align-items: flex-start;
                      flex-direction: column;
                    "
                  >
                    <span
                      style="margin-top: 8px; font-size: 16px; font-weight: 500"
                      >{{ item.networkName }}</span
                    >
                    <div style="margin-top: 10px">
                      <img
                        style="width: 16px; height: 16px"
                        src="../../assets/imgs/apply/position.png"
                        alt=""
                      />
                      <span style="margin-left: 5px"> {{ item.adress }} </span>
                    </div>
                    <div style="margin-top: 10px">
                      <img
                        style="width: 16px; height: 16px"
                        src="../../assets/imgs/apply/iphone.png"
                        alt=""
                      />
                      <span style="margin-left: 10px">{{ item.phone }} </span>
                    </div>
                  </div>
                </div>

                <div
                  v-if="adressList.length == 0"
                  style="
                    display: flex;
                    align-items: flex-start;
                    flex-direction: column;
                  "
                >
                  <span
                    style="margin-top: 8px; font-size: 16px; font-weight: 500"
                    >{{ bankName }}各营业网点</span
                  >
                </div>
              </div>
            </div>
            <div
              style="display: flex; align-items: flex-start; margin-top: 15px"
            >
              <div>
                <img
                  style="width: 48px; height: 40px"
                  src="../../assets/imgs/apply/link.png"
                  alt=""
                />
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  margin-left: 10px;
                  margin-top: 5px;
                "
              >
                <span
                  style="font-size: 16px; color: #2a2a2a; white-space: nowrap"
                  >线上办理产品链接：
                </span>
                <img
                  style="width: 108px; height: 108px"
                  :src="baseUrl + qrCode"
                  alt=""
                />
              </div>
            </div>
          </div>

          <el-button style="margin-top: 20px" type="primary" @click="getSuccess"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  detail,
  getDictionaryByCode,
  operate,
  queryProductInfoByTypeId,
  queryProductHandlingInfo,
} from "@/api/index";
import * as applyApi from "@/api/apply";
import baseUrl from "@/api/baseUrl";
export default {
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      id: "",
      dataList: [],
      typeName: "",
      dialogVisible: false,
      input: null,
      SourceType: "",
      success: false,
      dialogWidth: "660px",
      productId: "",
      adressList: [],
      Name: "",
      phone: "",
      qrCode: "",
      bankName: "",
    };
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth();
      })();
    };
    this.get_bodyHeight();
  },
  watch: {
    fullHeight(val) {
      //监控浏览器高度变化
      if (!this.timer) {
        this.fullHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
    input(val) {
      this.input = this.filterInput(val);
    },
  },
  computed: {},
  created() {
    this.SourceType = this.getSourceType;
    this.id = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    getSourceType: function () {
      return this.$store.getters.sourceType;
    },
    filterInput(val) {
      return val.replace(/[^\d]/g, "");
    },
    getqueryProductHandlingInfo() {
      let params = {
        productId: this.productId,
      };
      queryProductHandlingInfo(this.sendParam(params)).then((res) => {
        res = this.paramDecrypt(res);
        console.log(res);
        if (res.code == 200) {
          this.Name = res.data.productSpecialist;
          this.phone = res.data.phone;
          this.adressList = res.data.adressList;
          this.qrCode = res.data.qrCode;
          this.bankName = res.data.bankName;
        }
      });
    },
    Change() {
      if (!this.input) {
        this.$message.error("金额不能为空");
      } else {
        if (this.input < this.dataList.loanLimitFloor * 1) {
          this.$message.error(
            "您申请最小金额不得低于" + this.dataList.loanLimitFloor + "万"
          );
          // this.applymoney = this.prrductdetail.loanLimitFloor;
        }
        if (this.input > this.dataList.loanLimitCap * 1) {
          this.input = this.dataList.loanLimitCap;
          this.$message.error(
            "您可申请最大金额不得超过" + this.dataList.loanLimitCap + "万"
          );
        }
      }
    },
    setDialogWidth() {
      var val = document.body.clientWidth;
      const def = 370; // 默认宽度
      if (val < def) {
        this.dialogWidth = "100%";
      } else {
        this.dialogWidth = def + "px";
      }
    },
    show() {
      if (this.SourceType == 1) {
        this.dialogVisible = true;
      } else {
        this.$message.error("该账户权限不足");
      }
    },
    noShow() {
      if (this.SourceType == null) {
        this.$router.push({
          path: "/xyd/login",
        });
      }
    },
    get_bodyHeight() {
      //动态获取浏览器高度
      const that = this;
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          that.fullHeight = window.fullHeight;
        })();
      };
    },
    getDetail() {
      let params = {
        typeId: this.id,
      };
      queryProductInfoByTypeId(this.sendParam(params))
        .then((res) => {
          res = this.paramDecrypt(res);
          console.log(res);
          if (res.code == 200) {
            this.dataList = res.data;
            this.productId = res.data.id;
            // this.getCode(res.data.type)
          }
        })
        .catch((err) => {});
    },

    enter() {
      let params = {
        proId: this.dataList.id,
        operateType: "apply",
        appLimit: this.input,
      };
      operate(this.sendParam(params))
        .then((res) => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            this.success = true;
            this.getqueryProductHandlingInfo();
          } else {
            this.$message.error("请重新登录");
          }
        })
        .catch((err) => {});
      this.dialogVisible = false;
    },
    getSuccess() {
      this.success = false;
      location.reload();
      // if (this.dataList.webUrl !== "" && this.dataList.webUrl != null) {
      //   window.open(this.dataList.webUrl, "_blank");
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.success {
  .headImgs {
    img {
      width: 100%;
      height: 220px;
    }
  }
  .messageBox {
    width: 1280px;
    min-height: 570px;
    margin: 15px auto 0px;
    background-color: #fff;
    box-sizing: border-box;
    padding-bottom: 20px;
    .top {
      width: 100%;
      height: 210px;
      box-sizing: border-box;
      .name {
        width: 100%;
        height: 56px;
        padding: 0 40px 0 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f2f3f4;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
        box-sizing: border-box;
        .hander {
          img {
            width: 100px;
            height: 30px;
            vertical-align: middle;
            box-sizing: border-box;
          }
          span {
            font-size: 22px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            color: #2a2a2a;
            margin-left: 10px;
            box-sizing: border-box;
          }
        }
        .bankName {
          font-size: 14px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #595858;
          box-sizing: border-box;
        }
      }
      .details {
        width: 100%;
        height: 154px;
        padding: 30px;
        background: #ffffff;
        border: 1px solid #d5d5d5;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
        box-sizing: border-box;
        .top {
          border-left: 6px solid #2981ee;
          padding-left: 10px;
          height: 21px;
          font-size: 22px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #2a2a2a;
          line-height: 23px;
          box-sizing: border-box;
        }
        .btn {
          padding: 0 35px;
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          box-sizing: border-box;
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #8a8a8a;
          div {
            display: flex;
            flex-direction: column;
            div:nth-child(1) {
              margin-top: 5px;
              font-size: 30px;
              font-family: Alibaba PuHuiTi;
              font-weight: bold;
              color: #b90c1c;
            }
            span {
              margin-top: 5px;
              font-size: 30px;
              font-family: Alibaba PuHuiTi;
              font-weight: bold;
              color: #2a2a2a;
            }
          }
        }
      }
    }
  }
  .bottom {
    width: 100%;
    // min-height: 290px;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 30px;
    border: 1px solid #d5d5d5;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);

    .title {
      font-size: 22px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2a2a2a;
      border-left: 6px solid #2981ee;
      padding-left: 10px;
    }
    .list {
      div {
        margin-top: 30px;
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: 600;
        color: #2a2a2a;
        span {
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #2a2a2a;
        }
      }
    }
  }
  .button {
    margin: 10px auto 20px;
    color: #ffffff;
    text-align: center;
  }
}

/deep/ .el-dialog__body {
  .ipt {
    padding: 15px 0;
    /deep/ .el-input__inner {
      width: 80%;
    }
  }
}
</style>